/**
 * @description 远程配置 remoteConfig
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'

const remoteConfigBiz = new Logic()

remoteConfigBiz.findAll = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.remoteConfig.findAll,
    data: data
  })
}

remoteConfigBiz.delete = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.remoteConfig.delete,
    data: data
  })
}

remoteConfigBiz.save = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.remoteConfig.save,
    data: data
  })
}

remoteConfigBiz.update = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.remoteConfig.update,
    data: data
  })
}

remoteConfigBiz.test = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.remoteConfig.test,
    data: data
  })
}

export default remoteConfigBiz
